import { Button } from '@neo/primitives/button'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@neo/primitives/dialog'
import { Monitor } from 'lucide-react'
import { useLocation, useNavigate } from 'router-v6'
import { RbacModules, RbacPermissionTypes } from 'v2/types/rbac'
import { getSessionRoles } from 'v2/utils'
import { useMobile } from '../hooks/use-mobile'
import { usePermissions } from '../hooks/use-permissions'
import { isMobileAllowedPath } from '../utils/mobile-allowed-routes'
import { canViewBilling } from '../utils/role-based-visibility'

export const MobileBlockModal = () => {
  const isMobile = useMobile()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { hasPermission } = usePermissions()

  // Billing is usable on mobile, so don't block those routes.
  const onAllowedRoute = isMobileAllowedPath(pathname)

  // Only admin/finance can reach billing (same gate as the route), so only
  // offer the shortcut to users who can actually use it.
  const canAccessBilling =
    hasPermission(RbacModules.billing, RbacPermissionTypes.view) &&
    canViewBilling({ roles: getSessionRoles() })

  return (
    <Dialog open={isMobile && !onAllowedRoute}>
      <DialogContent
        showCloseButton={false}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="max-w-sm text-center"
        data-testid="mobile-block-modal"
      >
        <div className="flex flex-col items-center gap-4 py-4">
          <Monitor size={48} className="text-muted-foreground" />
          <DialogTitle className="text-h3-500">Desktop recommended</DialogTitle>
          <DialogDescription className="text-p-400 text-muted-foreground">
            {canAccessBilling
              ? 'Most of CX works best on desktop. You can still recharge and manage billing from your phone.'
              : 'This app works best on desktop. Please switch to a larger screen for the best experience.'}
          </DialogDescription>
          {canAccessBilling && (
            <Button
              className="mt-2"
              data-testid="mobile-block-go-to-billing"
              onClick={() => navigate('/billing/overview')}
            >
              Go to Billing
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
